
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/ascertain-service",
      function () {
        return require("private-next-pages/shop/ascertain-service/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/ascertain-service"])
      });
    }
  